const PRODUCT_LANDING = 'etp-su-criptovalute';

function acceptedProductLandings() {
    return ($.cookie('bw_product_disclaimer_accepted') || '').split(',').filter(Boolean);
}

$(document).ready(function () {
    const mentionedSwiper = new Swiper('.mentioned__slider', {
        spaceBetween: 0,
        loop: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        allowTouchMove: true,
        autoplay: {
            delay: 0,
            disableOnInteraction: false
        },
        freeMode: true,
        speed: 70000,
    });

    calcArticleGridHeight();

    $('[data-element=newsarticle-toggler]').click(function () {
        $(this).toggleClass('btn-icon-chevron-down');
        $(this).toggleClass('btn-icon-chevron-up');
        $(this).closest('.newsarticle').find('.newsarticle__list').toggleClass('active');
    })

    const furtherSwiper = new Swiper('.further__slider', {
        spaceBetween: 10,
        slidesPerView: 1.35,
        direction: "horizontal",
        mousewheel: {
            forceToAxis: true
        },
        freeMode: {
            enabled: true,
            sticky: true,
            minimumVelocity: 1,
            momentumBounce: false,
            momentum: false
        },
        // breakpoints: {
        //     992: {
        //         spaceBetween: 30,
        //         slidesPerView: 3.75,
        //     }
        // }
    });

    closedFaq();

    $('#faqToggler').click(function () {
        $('#faqQuestions .collapse__container').removeClass('d-none')
        $(this).remove()
    })

    $('#kryptowaehrungenForm').on('change', function () {
        let inputs = $(this).find(':required');
        let inputsFilled = $(this).find(':required:not(:placeholder-shown, [type=checkbox])');
        let checkboxChecked = $(this).find(':checked');
        let subscribe = $(this).find('[type=submit]')

        let trigger = (inputsFilled.length + checkboxChecked.length) == inputs.length;

        if (trigger == false) $(subscribe).prop('disabled', true);
        if (trigger != false) $(subscribe).prop('disabled', false);
    })

    const scrollSpy = function (isInitialLoad) {
        const sections = $('.scroll-spy-section');
        let currentSection = '';
        let offsetTopTabs = $(window).width() < 991 ? 80 : 173;
        offsetTopTabs += 300; // add spacing between tabs and target

        sections.each(function () {
            const sectionTop = $(this).offset().top;

            if ($(window).scrollTop() >= sectionTop - offsetTopTabs) {
                currentSection = $(this).attr('id');
            }
        });

        const navLinks = $('.nav-link');

        navLinks.each(function () {
            if (isInitialLoad) {
                const initialSection = sections.filter(function () {
                    const sectionTop = $(this).offset().top;
                    const sectionBottom = sectionTop + $(this).outerHeight();
                    return (
                        $(window).scrollTop() >= sectionTop - offsetTopTabs &&
                        $(window).scrollTop() < sectionBottom
                    );
                }).first();

                const sectionId = initialSection.length ? '#' + initialSection.attr('id') : '#' + sections.first().attr('id');

                if ($(this).data('scrollspy-target') !== sectionId && !isInitialLoad) {
                    $(this).removeClass('active');
                    return;
                }

                if ($(this).data('scrollspy-target') === sectionId) {
                    $(this).addClass('active');
                } else {
                    $(this).removeClass('active');
                }

                return;
            }

            if ($(this).data('scrollspy-target') === '#' + currentSection) {
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');
                }
            } else {
                $(this).removeClass('active');
            }
        });
    };

    scrollSpy(true);

    $(window).on('scroll', function () {
        scrollSpy();
    });

    if (acceptedProductLandings().includes(PRODUCT_LANDING)) {
        $('#prodBlocker').remove();
    } else {
        new CustomSelect('#prodBlockerCountry');
    }
})

function calcArticleGridHeight() {
    $('[data-element=newsarticle-grid]').each(function () {
        var heights = [];

        $(this).find('[data-element=newsarticle]').each(function () {
            heights.push($(this).outerHeight());
        })

        var tallest = heights.reduce((prev, cur) => {
            if (cur > prev) {
                return cur
            } else return prev;
        }, 0);

        $(this).attr('style', `--row-h: ${tallest}px`)
    })
}

function closedFaq() {
    $('#faqQuestions .collapse__container').each(function (index) {
        $(this).toggleClass('d-none', index > 4)
    })
}

$('[data-videocard-img]').click(function(){$(this).remove()});

$('#prodBlockerAccept').click(function(){
    $('#prodBlocker').addClass('accepted');
    setTimeout(()=> $('#prodBlocker').remove(), 290);
    let selected_country = $(this).closest('#prodBlocker').find('#prodBlockerCountry [data-selected-option-value]').attr('data-selected-option-value');
    $.cookie('bw_product_disclaimer_accepted', acceptedProductLandings().concat(PRODUCT_LANDING).join(','), { path: '/', secure: true });

    window.howToBuyBrokersSelect.selectOption(document.querySelector(`[data-option-value="${selected_country}"]`));
})